export default class GroupMessageProvider {

    constructor() {}

    getGroupNameSingularKey = () => {
        //abstract
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/GroupMessageProvider.js